import { RhinoError } from './error';

export function isRhinoError(error: unknown): error is RhinoError {
  return error instanceof RhinoError;
}

export function isRhinoNetworkError(error: unknown) {
  return isRhinoError(error) && error.code === 'NETWORK_ERROR';
}

export function getRhinoErrorContext(error: RhinoError) {
  return error.context?.nativeError as undefined | Partial<{ message: string; code: string }>;
}
